import moment from 'moment';
import { ACITONCOPYRIGHT, ACTIONBASEINFO } from '../../../actionTypes';
export function filterCallback(array) {
	let tempData = [];
	if (!(array instanceof Array)) {
		return tempData;
	}
	for (let i = 0, j = array.length; i < j; i++) {
		tempData.push(array[i].split('|')[0]);
	}
	return tempData;
}
export function getCityList(payload, callback, errorCallback) {
	return {
		type: ACTIONBASEINFO.FETCH_BASEINFO_CITYLIST,
		payload,
		callback,
		errorCallback
	};
}
export function getActivityDetail(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_ACTIVITY_DETAIL,
		payload,
		callback,
		errorCallback
	};
}
export function putImgInfo(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_IMGINFO,
		payload,
		callback,
		errorCallback
	};
}
export function getUploadToken(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_UPLOAD_TOKEN,
		payload,
		callback,
		errorCallback
	};
}
export function getRedisKey(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_UPLOAD_REDISKEY,
		payload,
		callback,
		errorCallback
	};
}
